(function () {
  'use strict';

  angular
      .module('eltazkara.config', [])

})();
